import misConfigIcon from "../../../assets/onprem_misconfig.svg";
import { Stack, Tooltip } from "@mui/material";

const MisconfigCellRenderer = (params: {
  data: {
    vulnerability_levels: {
      low_count: number;
      high_count: number;
      failed_count: number;
      medium_count: number;
      passed_count: number;
      critical_count: number;
    }
  };
}) => {
  return (
   <Tooltip
  title={`Failed: ${params.data.vulnerability_levels.failed_count ?? 0}`}
  arrow
  slotProps={{
    tooltip: {
      sx: {
        backgroundColor: "#fff", // white background
        color: "#000",           // black text
        boxShadow: 1,
        fontSize: "0.775rem",
      },
    },
    arrow: {
      sx: {
        color: "#fff", // arrow also white
      },
    },
  }}
>
  <Stack direction="row" alignItems="center" className="ag-center">
    <img
      src={misConfigIcon}
      alt="misconfig-icon"
      style={{ width: "20px", marginRight: "5px" }}
    />
    <span>{params.data.vulnerability_levels.failed_count ?? 0}</span>
  </Stack>
</Tooltip>

  );
};

export default MisconfigCellRenderer;
